import { useAppDispatch } from 'store';
import { useSelectedCloverDevice } from 'hooks';
import { Select } from 'components/select/select';
import { isSingleSelectValue } from 'utils/helpers';
import { setSelectedDevice } from 'store/slices/clover-devices';

import { SelectCloverDeviceProps } from './types';

export const SelectCloverDevice = ({
  event,
  label,
  className,
}: SelectCloverDeviceProps) => {
  const dispatch = useAppDispatch();
  const { deviceOptions, selectedDevice } = useSelectedCloverDevice(event);

  const selectedValue = deviceOptions?.find(
    (value) => value.value === selectedDevice?.id
  );

  const isMultiDevices = deviceOptions?.length > 1;

  if (!isMultiDevices) {
    return null;
  }

  return (
    <Select
      className={className}
      value={selectedValue}
      options={deviceOptions}
      placeholder="Select Device"
      label={label || 'Select Device'}
      onChange={(value) => {
        if (isSingleSelectValue(value)) {
          dispatch(
            setSelectedDevice({
              eventId: event.id,
              deviceId: Number(value?.value),
            })
          );
        }
      }}
    />
  );
};
